import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import { toggleLogIn, toggleSignUp } from 'js/helpers/loginActions';
import Button from 'js/components/shared/Button';

import styles from './BecomeMemberBanner.module.scss';
import {sanitizeContent} from 'js/shared/security';

const cx = classnames.bind(styles);

const onSignUpClick = function (e) {
  e.preventDefault();
  e.stopPropagation();
  toggleSignUp();
}

const onLogInClick = function (e) {
  e.preventDefault();
  e.stopPropagation();
  toggleLogIn();
}

const BecomeMemberBanner = ({
  className,
  data: {
    bannerText,
    bannerImage,
    bannerSignUpLink,
    bannerLoginDescription,
    bannerLoginLink,
    textColor = '#ffffff',
    backgroundColor = '#280052',
  }
}) => {
  const bannerStyles = {
    backgroundColor,
    color: textColor
  }

  return (
    <div style={bannerStyles} className={cx('root', className)}>
      {bannerImage && (<div className={cx('logo')}>
        <img src={bannerImage} alt="" loading="lazy" />
      </div>)}
      {bannerText?.value && (
        <div className={cx('message')} dangerouslySetInnerHTML={{__html: sanitizeContent(bannerText?.value)}}/>
      )}
      <div className={cx('navigate')}>
        {bannerSignUpLink && (
          <Button
            className={cx('sign-up')}
            color="white-reverse"
            theme="rounded"
            size="sm"
            onClick={onSignUpClick}
          >
            {bannerSignUpLink}
          </Button>
        )}
        {bannerLoginLink && (
          <p>
            {bannerLoginDescription && (<span>{bannerLoginDescription}</span>)}
            <Button
              className={cx('log-in')}
              theme="link"
              onClick={onLogInClick}
            >
              {bannerLoginLink}
            </Button>
          </p>
        )}
      </div>
    </div>
  )
}

BecomeMemberBanner.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    bannerText: PropTypes.shape({
      value: PropTypes.string.isRequired,
    }),
    bannerImage: PropTypes.string,
    bannerSignUpLink: PropTypes.string,
    bannerLoginDescription: PropTypes.string,
    bannerLoginLink: PropTypes.string,
    textColor: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired
}

export default BecomeMemberBanner;
